import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getHtmlLangFromRouteLanguage } from '../../utils/languageRouting';

export default function DocumentLanguage() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const language = (i18n.resolvedLanguage || i18n.language || 'hk').split('-')[0];
    const direction = language === 'ug' ? 'rtl' : 'ltr';

    document.documentElement.lang = getHtmlLangFromRouteLanguage(language);
    document.documentElement.dir = direction;
    document.body.dir = direction;
  }, [i18n.language, i18n.resolvedLanguage]);

  return null;
}
